import { VeType } from 'storeTypes/vesTypes'
import { VillageType } from './appTypes'

export const extractVillages = (ves: unknown = []): Partial<VillageType>[] => {
    if (!Array.isArray(ves)) {
        return []
    }

    const villages = {} as Record<string, Partial<VillageType>>

    ves.forEach((ve) => {
        const record = ve as VeType | null
        if (!record || !Array.isArray(record.ve_villages)) {
            return
        }

        record.ve_villages.forEach(({ name, code, sf_id: sfId }) => {
            if (villages[code]) {
                villages[code]?.ves?.push(record)
            } else {
                villages[code] = {
                    name,
                    code,
                    sf_id: sfId,
                    ves: [record]
                }
            }
        })
    })

    return Object.values(villages)
}
